import { WebConfig, IWebConfig, getWebConfig } from './../../app-web';
import { Component, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { FormArray, FormGroup } from '@ngneat/reactive-forms';
import { Subscription } from 'rxjs';
import { AppInjector } from 'src/app/app-injector';
import { AppService } from 'src/app/app.service';
import { AuthenticationService, TokenUser } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';
import { AgentTypesType } from '../constants/agent-types';
import {
  AppPath,
  BankPath,
  CreditPath,
  CUPath,
  DashboardPath,
  LogPaths,
  ManageMemberPath,
  MarketingPath,
  MemberOutstanding,
  OperatorPath,
  ProfilePath,
  ReportsPath,
  SettingPaths,
  SmsPaths,
  SupportAdminPaths,
  TransactionPath,
  UserPath,
} from '../constants/paths';
import * as moment from 'moment';
import { UserRoles, UserRolesType } from '../constants/user-roles';
import { Agent } from 'src/app/apis/agent.service';
import { IIpAddress, IPreloadSystem } from 'src/app/apis/preload-system.service';
import { PRELOAD_SYSTEM } from '../constants/preload';

@Component({
  template: '',
})
export abstract class AppCore implements OnDestroy {
  //#region  || --------------- preload value system
  constDataPreload: IPreloadSystem = PRELOAD_SYSTEM;
  //#endregion

  //#region  || --------------- Path Url
  AppPath = AppPath;
  DashboardPath = DashboardPath;
  ManageMemberPath = ManageMemberPath;
  MemberOutstanding = MemberOutstanding;
  TransactionPath = TransactionPath;
  CreditPath = CreditPath;
  BankPath = BankPath;
  OperatorPath = OperatorPath;
  CUPath = CUPath;
  UserPath = UserPath;
  ProfilePath = ProfilePath;
  SettingPaths = SettingPaths;
  marketingPath = MarketingPath;
  reportPaths = ReportsPath;
  supportAdminPaths = SupportAdminPaths;
  smsPaths = SmsPaths;
  logPaths = LogPaths;
  //#endregion

  //#region  || -------------- Host API
  apiHost = environment.origin;
  imgHost = environment.image;
  //#endregion

  //#region  || -------------- Service
  svAuth = AppInjector.get(AuthenticationService);
  svApp = AppInjector.get(AppService);
  //#endregion

  //#region  || -------------- User
  currentAgentId: number;
  currentAgent: Agent;
  currentUser: TokenUser = this.svAuth.getUser;
  //#endregion

  //#region  || -------------- condition about role
  isSuperAdmin = (['Superadmin'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isAdmin = (['Superadmin', 'Admin'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isShareholder = (['Shareholder'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );
  isSeniorAgent = (['Senior Agent'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );
  isMasterAgent = (['Master Agent'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );
  isAgent = (['Agent'] as AgentTypesType[]).some((at) => at === this.currentUser?.AgentType);
  isOperator = (['Operator'] as UserRolesType[]).some((usr) =>
    this.currentUser?.Role?.some((r) => r === usr)
  );
  isShowMasterAgent = (['Master Agent', 'Senior', 'Shareholder'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );
  isShowSenior = (['Senior', 'Shareholder'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );
  isShowShareHolder = (['Shareholder'] as AgentTypesType[]).some(
    (at) => at === this.currentUser?.AgentType
  );

  isPermission = this.isSuperAdmin || this.isAdmin || this.isOperator;

  isMemberPassword = (['Member Password'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isMemberManagement = (['MemberManagement'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isMemberManagementView = (['MemberManagementView'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isDeposit = (['Deposit'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  isWithdraw = (['Withdraw'] as UserRolesType[]).some((role) =>
    this.currentUser?.Role?.some((ur) => ur === role)
  );
  //#endregion

  // priorityManageMember = 0;

  FilterDay: 'yesterday' | 'week' | 'month';

  Subscriptions: Subscription = new Subscription();

  Config: IWebConfig = getWebConfig();
  env = environment;

  constructor() {
    // if (this.isMemberManagement) {
    //   this.priorityManageMember = 0;
    // } else if (this.isMemberPassword) {
    //   this.priorityManageMember = 1;
    // } else if (this.isMemberManagementView) {
    //   this.priorityManageMember = 2;
    // }

    this.Subscriptions.add(
      this.svApp.getAgentId$.subscribe((res) => {
        this.currentAgentId = res;
        this.agentIdChange();
      })
    );
    this.Subscriptions.add(
      this.svApp.getCurrentAgent$.subscribe((res) => {
        this.currentAgent = res;
        this.currentAgentChanged();
      })
    );

    // this.Subscriptions.add(
    //   this.svApp.getPreloadSystem$.subscribe((res) => {
    //     if (res) {
    //       this.constDataPreload = res;
    //       this.onPreloadReady();
    //     }
    //   })
    // );
  }

  // OnInitSystemAgent(): void {}

  agentIdChange(): void {}
  currentAgentChanged(): void {}

  ngOnDestroy() {
    this.Subscriptions.unsubscribe();
  }

  getFormArray(group: FormGroup | AbstractControl, name: string) {
    return group.get(name) as FormArray<FormGroup>;
  }

  // onPreloadReady() {
  //   if (this.constDataPreload) {
  //     this.OnInitSystemAgent();
  //   }
  // }

  getRouteMemberProfile(memberId: number, route = '') {
    if (route) {
      return ['', AppPath.manageMember, ManageMemberPath.profile, memberId, route];
    } else {
      return ['', AppPath.manageMember, ManageMemberPath.profile, memberId];
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  clickBtnClose(id: string) {
    const btnCloseEl = document.getElementById(id) as HTMLButtonElement;
    btnCloseEl?.click();
  }

  selectDate(type: IFilterDay = 'today'): IFromToDate {
    switch (type) {
      case 'today': {
        return {
          from: moment().format('YYYY-MM-DDT11:00'),
          to: moment().add(1, 'day').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'yesterday': {
        return {
          from: moment().subtract(1, 'day').format('YYYY-MM-DDT11:00'),
          to: moment().format('YYYY-MM-DDT11:00'),
        };
      }
      case 'week': {
        return {
          from: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DDT11:00'),
          to: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DDT11:00'),
        };
      }
      case '2week': {
        return {
          from: moment()
            .subtract(2, 'week')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DDT11:00'),
          to: moment().subtract(2, 'week').endOf('week').add(1, 'days').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'month': {
        return {
          from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDT11:00'),
          to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'thismonth': {
        return {
          from: moment().startOf('month').format('YYYY-MM-DDT11:00'),
          to: moment().endOf('month').format('YYYY-MM-DDT11:00'),
        };
      }
      default: {
        return {
          from: moment().startOf('date').format('YYYY-MM-DDT11:00'),
          to: moment().endOf('date').format('YYYY-MM-DDT11:00'),
        };
      }
    }
  }
  selectDate11h00m(type: IFilterDay = 'today'): IFromToDate {
    const today = moment().unix();
    const todayH11M00 = moment(moment().format('YYYY-MM-DDT11:00')).unix();
    switch (type) {
      case 'today': {
        if (today > todayH11M00) {
          return {
            from: moment().format('YYYY-MM-DDT11:00'),
            to: moment().add(1, 'day').format('YYYY-MM-DDT11:00'),
          };
        } else {
          return {
            from: moment().subtract(1, 'day').format('YYYY-MM-DDT11:00'),
            to: moment().format('YYYY-MM-DDT11:00'),
          };
        }
      }
      case 'yesterday': {
        if (today > todayH11M00) {
          return {
            from: moment().subtract(1, 'day').format('YYYY-MM-DDT11:00'),
            to: moment().format('YYYY-MM-DDT11:00'),
          };
        } else {
          return {
            from: moment().subtract(2, 'day').format('YYYY-MM-DDT11:00'),
            to: moment().subtract(1, 'day').format('YYYY-MM-DDT11:00'),
          };
        }
      }
      case 'week': {
        return {
          from: moment()
            .subtract(1, 'week')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DDT11:00'),
          to: moment().subtract(1, 'week').endOf('week').add(2, 'days').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'thisweek': {
        return {
          from: moment()
            .subtract(1, 'week')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DDT11:00'),
          to: moment().subtract(1, 'week').endOf('week').add(2, 'days').format('YYYY-MM-DDT11:00'),
        };
      }
      case '2week': {
        return {
          from: moment()
            .subtract(2, 'week')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DDT11:00'),
          to: moment().subtract(2, 'week').endOf('week').add(1, 'days').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'thismonth': {
        return {
          from: moment().startOf('month').format('YYYY-MM-DDT11:00'),
          to: moment().endOf('month').format('YYYY-MM-DDT11:00'),
        };
      }
      case 'month': {
        return {
          from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDT11:00'),
          to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DDT11:00'),
        };
      }
      default: {
        return {
          from: moment().subtract(1, 'day').format('YYYY-MM-DDT11:00'),
          to: moment().format('YYYY-MM-DDT11:00'),
        };
      }
    }
  }

  randomFullName() {
    const firstNames = ['John', 'Jane', 'Alex', 'Sara', 'Mike', 'Nina', 'Tom', 'Lily'];
    const lastNames = ['Smith', 'Johnson', 'Lee', 'Brown', 'Davis', 'Miller', 'Wilson', 'Taylor'];
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    return `${firstName} ${lastName}`;
  }
  randomPassword() {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
    let password = '';
    for (let i = 0; i < 12; i++) {
      password += chars[Math.floor(Math.random() * chars.length)];
    }
    return password;
  }
  randomUsername() {
    const names = [
      'coolcat',
      'happybee',
      'silentfox',
      'fasttiger',
      'sleepykoala',
      'luckyduck',
      'bluesky',
      'redsun',
      'greenleaf',
      'brightmoon',
    ];
    const number = Math.floor(Math.random() * 1000); // 0–999
    return `${names[Math.floor(Math.random() * names.length)]}${number}`;
  }
}

export type IFilterDay =
  | 'yesterday'
  | 'week'
  | 'thisweek'
  | '2week'
  | 'month'
  | 'thismonth'
  | 'today';
export interface IFromToDate {
  from: string;
  to: string;
}
